<template>
  <div>
    <v-alert :type="alertType" variant="tonal" :border="alertBorder">
      {{ alertMessage }}
    </v-alert>
  </div>
</template>

<script>

export default {
  name: "ShowAlert",
  props: {
    alertType: {
      type: String,
      default: "warning",
    },
    alertMessage: {
      type: String,
      default: "",
    },
    borderPosition: {
      type: String,
      default: "start",
    },
  },
  computed: {
    alertBorder() {
      const legacy = { left: "start", right: "end" };
      const value = legacy[this.borderPosition] ?? this.borderPosition;
      return ["top", "end", "bottom", "start"].includes(value) ? value : "start";
    },
  },
};
</script>

<style scoped>

</style>
